import { render, staticRenderFns } from "./CCMMedicationEventViewDialog.vue?vue&type=template&id=df915316"
import script from "./CCMMedicationEventViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMMedicationEventViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports